/* eslint-disable no-unused-vars */

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";

window.addEventListener('DOMContentLoaded', () => {
  Fancybox.bind('[data-fancybox="gallery"]', {
    Thumbs: false,
    Toolbar: {
      display: ['close'],
    },
    dragToClose: false,
    animated: true,
  });
});

/* eslint-enable no-unused-vars */
